/* 🤖 this file was generated by svg-to-ts */
export const matIconHotelClass: {
  name: 'hotel-class';
  data: string;
} = {
  name: 'hotel-class',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m11 8.89.94 3.11h2.82l-2.27 1.62.93 3.01L11 14.79l-2.42 1.84.93-3.01L7.24 12h2.82L11 8.89zM8.58 10H1l6.17 4.41L4.83 22 11 17.31 17.18 22l-2.35-7.59L21 10h-7.58L11 2l-2.42 8zm12.78 12-1.86-6.01L23.68 13h-3.44l-3.08 2.2 1.46 4.72L21.36 22zM17 8l-1.82-6-1.04 3.45.77 2.55H17z"/></svg>`
};
